import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/tenant-templates/')({
  staticData: { breadcrumb: 'Client Onboarding Templates', breadcrumbKey: 'K_BREADCRUMB_TENANT_TEMPLATES' },
});
